import i18n from 'i18next';

export const getQuestionnaireName = (questionnaireType: string) => {
  switch (questionnaireType) {
    case 'KYC_FINANCIAL_ADVISORY':
      return i18n.t('customer.serviceInfo.checklist.questionnaire.kycFinancialAdvisory');
    case 'KYC_WEALTH_MANAGEMENT':
      return i18n.t('customer.serviceInfo.checklist.questionnaire.kycWealthManagement');
    case 'MIFID_CLIENT_CATEGORISATION':
      return i18n.t('customer.serviceInfo.checklist.questionnaire.mifidClientCategorisation');
    case 'MIFID_APPROPRIATENESS':
      return i18n.t('customer.serviceInfo.checklist.questionnaire.mifidAppropriateness');
    case 'MIFID_SUITABILITY':
      return i18n.t('customer.serviceInfo.checklist.questionnaire.mifidSuitability');
    default:
      console.log('Unable to retrieve item name');
  }
};

export const convertDate = (timestamp: string) => new Date(timestamp)
  .toLocaleDateString('en-GB')
  .replace(/\//g, '.');

export const convertDateTime = (timestamp: string) => new Date(timestamp)
  .toLocaleString('en-GB')
  .replace(/\//g, '.')
  .replace(/,/g, ' ');
